import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=5c1dcb3a"
import script from "./Configure.vue?vue&type=script&lang=ts"
export * from "./Configure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports